import { getStoredPlacePhotoUrl } from "@/utils/googlePlaces";

type EntityImageSource = {
  canonical?: { image_url?: string };
  canonical_image_url?: string;
  image_url?: string;
  enrichment_data?: { image?: { url?: string }; google_places?: { photos?: unknown[] } };
  google_places?: { photos?: unknown[] };
  photo_uri?: unknown;
};

/** Use image metadata already carried by the shared entity; never fetch a photo. */
export function entityImageUrl(entity?: EntityImageSource | null): string | undefined {
  const places = entity?.google_places || entity?.enrichment_data?.google_places;
  return entity?.canonical?.image_url
    || entity?.canonical_image_url
    || entity?.image_url
    || entity?.enrichment_data?.image?.url
    || getStoredPlacePhotoUrl(places?.photos?.[0])
    || getStoredPlacePhotoUrl(entity?.photo_uri);
}
